// extracted by mini-css-extract-plugin
module.exports = {"avatar":"_21KS9","svgAvatar":"_39yW2","imageAvatar":"wD3Xo"};